var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"sy-tree"},[_c('virtual-list',{ref:"virtualList",staticClass:"sy-tree__nodes",attrs:{"data-key":'key',"data-sources":_vm.flattenedNodes,"data-component":_vm.itemComponent,"extra-props":{
        multiple: _vm.multiple,
        expandedNodeKeys: _vm.expandedNodeKeys,
        collapse: _vm._collapse,
        expand: _vm._expand,
        labelClick: _vm._labelClick,
        checkboxClick: _vm._checkboxClick,
        mustLeaf: _vm.mustLeaf,
        focusNode: _vm.focusNode,
        selectedNodeSingle: !_vm.multiple && _vm.selectedNodes.simpleNodes.length ? _vm.selectedNodes.simpleNodes[0] : null,
        itemRender: _vm.$scopedSlots.default,
        contentWidthFull: _vm.contentWidthFull,
        progenyIndicator: _vm.progenyIndicator,
        showLine: _vm.showLine,
        mode: _vm.mode
      },"page-mode":_vm.pageMode,"keeps":_vm.realKeeps}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }